import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BadgeCheck, Copy, LayoutTemplate, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";

export const useTemplate = () => {
  const api = useApi();
  const nav = useNavigate();
  const [busy, setBusy] = useState(null);
  const use = async (id) => {
    setBusy(id);
    try { const k = await api("post", `/hte/kajian/${id}/guna-templat`); toast.success("Program baharu dicipta daripada templat (tiada kuota)"); nav(`/kajian/${k.id}`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return { use, busy };
};

export const UseTemplateButton = ({ id, testid, className = "" }) => {
  const { use, busy } = useTemplate();
  return (
    <button onClick={() => use(id)} disabled={!!busy} data-testid={testid}
      className={`h-9 px-4 rounded-full bg-ink text-bg text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-40 ${className}`}>
      {busy ? <Loader2 size={14} className="animate-spin" /> : <Copy size={14} />} Guna Templat
    </button>
  );
};

const Cards = ({ items, prefix }) => (
  <div className={`grid gap-3 ${items.length > 1 ? "md:grid-cols-2" : ""}`}>
    {items.map((t) => (
      <div key={t.id} className="rounded-2xl border border-line p-4 flex items-start justify-between gap-3" data-testid={`${prefix}-card-${t.id}`}>
        <div className="min-w-0">
          <div className="font-display text-base text-ink line-clamp-2">{t.tajuk}</div>
          <div className="text-xs text-mute mt-1 truncate">{t.program?.peserta} · {t.program?.tempoh} · {t.rujukan}</div>
        </div>
        <UseTemplateButton id={t.id} testid={`${prefix}-use-${t.id}`} className="shrink-0" />
      </div>
    ))}
  </div>
);

export const OfficialTemplates = () => {
  const api = useApi();
  const [items, setItems] = useState([]);
  useEffect(() => { api("get", "/hte/templat-rasmi").then(setItems).catch(() => setItems([])); }, [api]);
  if (!items.length) return null;
  return (
    <section className="space-y-3" data-testid="official-template-list">
      <div className="eyebrow inline-flex items-center gap-2 !text-q"><BadgeCheck size={14} /> Templat Rasmi ATAS · contoh program untuk semua trainer</div>
      <Cards items={items} prefix="official-template" />
    </section>
  );
};

export const TemplateList = ({ items: given }) => {
  const api = useApi();
  const [items, setItems] = useState(given || null);
  useEffect(() => { if (!given) api("get", "/kajian").then((xs) => setItems(xs.filter((x) => x.templat))).catch(() => setItems([])); else setItems(given); }, [api, given]);
  if (!items || items.length === 0) return null;
  return (
    <section className="space-y-3" data-testid="template-list">
      <div className="eyebrow inline-flex items-center gap-2"><LayoutTemplate size={14} /> Templat Saya · mula dengan satu klik, tanpa kuota</div>
      <Cards items={items} prefix="template" />
    </section>
  );
};
